<template>
  <ItemPriceTrial
    :imageUrl="imageUrl"
    :price="price"
    :step="step"
    :showButtons="trial.component === 'one_image_one_label_two_buttons'"
    @answered="handleResponse"
  />
</template>
<script>
import ItemPriceTrial from '@/components/exams/item-price/ItemPriceTrial.vue'
import essComponentProps from '@/mixins/essComponentProps'
import { ntDate } from '@neurotrack/web-core'

export default {
  name: 'one_image_one_label',
  data() {
    return {
      trial_start_time: null
    }
  },
  components: { ItemPriceTrial },
  mixins: [essComponentProps],
  watch: {
    step: {
      handler() {
        this.trial_start_time = ntDate.now()
      },
      immediate: true
    }
  },
  methods: {
    handleResponse(value) {
      const { trial_start_time } = this
      const data =
        value === null
          ? []
          : [
            {
              type: 'selection',
              value
            }
          ]
      this.handleTrialResponse({
        exam_trial_id: this.trial.exam_trial_id,
        trial_start_time,
        trial_end_time: ntDate.now(),
        metadata: {
          trial_scoring_type: this.trial.trial_scoring_type
        },
        data,
        timeout: value === null
      })
    }
  },
  computed: {
    body() {
      return this.trialData.body || {}
    },
    imageUrl() {
      const img = this.body.leading_image?.filename || ''
      if (img) {
        return this.getImageUrl(img)
      }
      return img
    },
    price() {
      const { price_label } = this.body
      if (price_label) {
        return `${price_label.text}`
      }
      return ''
    }
  }
}
</script>
